// @ts-check
import { filter, get, values, keyBy, forEach, partition, size } from "lodash";

import { newConstraintGrouping } from "../../util";

export default ({
  rootGroup,
  groupLookup,
  columnCount,
  hideHiddenTeams,
  groupTypes,
}) => {
  // collect all our possible source groups

  // find all unallocatable source groups
  const unallocateableSourceGroupTypes = keyBy(
    filter(
      values(groupTypes),
      (gt) => gt.isSupply && !gt.isSupplySource && !(size(gt.childTypes) > 0)
    ),
    "id"
  );

  let sourceGroupsYetToInsert = filter(values(groupLookup), (g) => g.isSource);
  let sourceGroupsToInsert = [];
  const rootGrouping = newConstraintGrouping({
    group: rootGroup,
    parentGrouping: null,
    groupId: rootGroup.id,
    nestedLevel: 0,
    isSupply: rootGroup.isSource,
    isDemand: !rootGroup.isSource,
    isRoot: true,
    memberCount: rootGroup.memberCount,
    capacityFte: get(rootGroup, "totalCapacityFte", 0),
    isVirtualDirectConstraintGrouping: false,
    canAllocate: !unallocateableSourceGroupTypes[rootGroup.type],
    columnCount,
  });
  rootGrouping.root = rootGrouping;
  const groupingsLookup = { [rootGrouping.id]: rootGrouping };
  // insert the groups in order from highest hierarchy level to lowest.
  for (let hierarchyLevel = 0; hierarchyLevel < 999; hierarchyLevel += 1) {
    [sourceGroupsToInsert, sourceGroupsYetToInsert] = partition(
      sourceGroupsYetToInsert,
      (s) => s.parentIds.length === hierarchyLevel
    );

    forEach(sourceGroupsToInsert, (sourceGroup) => {
      if (hideHiddenTeams && (sourceGroup.isHidden || sourceGroup.isDeleted)) {
        return;
      }

      const parentGrouping = groupingsLookup[sourceGroup.directParentId];
      if (!parentGrouping) {
        // eslint-disable-next-line no-console
        console.warn(
          `ignoring group '${sourceGroup.id}'. Cannot find not parent '${sourceGroup.directParentId}'`
        );
        return;
      }

      const grouping = newConstraintGrouping({
        group: sourceGroup,
        parentGrouping,
        groupId: sourceGroup.id,
        nestedLevel: parentGrouping.nestedLevel + 1,
        memberCount: sourceGroup.memberCount,
        isSupply: true,
        capacityFte: get(sourceGroup, "totalCapacityFte", 0),
        isVirtualDirectConstraintGrouping: false,
        canAllocate: !unallocateableSourceGroupTypes[sourceGroup.type],
        columnCount,
      });
      if (parentGrouping.childGroupings.length === 0) {
        // push a direct member grouping
        const directMembersGrouping = newConstraintGrouping({
          group: parentGrouping.group,
          parentGrouping,
          groupId: parentGrouping.groupId,
          nestedLevel: parentGrouping.nestedLevel + 1,
          memberCount: parentGrouping.memberCount,
          isSupply: true,
          capacityFte: get(parentGrouping.group, "directMembersCapacityFte", 0),
          isVirtualDirectConstraintGrouping: true,
          canAllocate: false,
          columnCount,
        });
        parentGrouping.childGroupings.push(directMembersGrouping);
      }
      parentGrouping.childGroupings.push(grouping);
      groupingsLookup[grouping.id] = grouping;
    });

    if (sourceGroupsYetToInsert.length === 0) {
      break;
    }
  }

  const sortGroupings = (groupings) => {
    // sort priority:
    //   1: virtual direct member grouping first
    //   2: by name

    groupings.sort((a, b) => {
      if (a.isVirtualDirectConstraintGrouping) {
        return -1;
      }

      if (b.isVirtualDirectConstraintGrouping) {
        return 1;
      }

      // sort by name third
      return a.group.name.localeCompare(b.group.name);
    });

    forEach(groupings, (grouping) => {
      if (grouping.childGroupings) {
        sortGroupings(grouping.childGroupings);
      }
    });
  };

  sortGroupings(rootGrouping.childGroupings);

  return [rootGrouping];
};
